var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSsl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.41104 5.19619C10.2345 4.35521 11.3543 3.86986 12.531 3.844C15.047 3.796 17.094 5.891 17.094 8.406V9.562C17.0948 9.61152 17.0857 9.66069 17.0671 9.70661C17.0486 9.75252 17.021 9.79425 16.986 9.82932C16.9511 9.86438 16.9094 9.89207 16.8635 9.91074C16.8177 9.9294 16.7685 9.93868 16.719 9.938H15.813C15.602 9.938 15.438 9.773 15.438 9.562V8.281C15.438 6.695 14.098 5.41 12.5 5.469C10.98 5.523 9.812 6.82 9.812 8.343V9.563C9.81254 9.61226 9.80323 9.66114 9.78462 9.70675C9.76602 9.75237 9.73849 9.79381 9.70365 9.82865C9.66881 9.86349 9.62737 9.89102 9.58175 9.90962C9.53614 9.92823 9.48726 9.93754 9.438 9.937H8.5C8.289 9.937 8.125 9.773 8.125 9.563V8.344C8.12602 7.16702 8.58762 6.03718 9.41104 5.19619Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.094 11.156C6.094 10.695 6.477 10.344 6.938 10.344H18.25C18.711 10.344 19.094 10.696 19.094 11.156V17.625C19.094 18.086 18.71 18.438 18.25 18.438H6.938C6.477 18.438 6.094 18.085 6.094 17.625V11.156ZM14.156 13.563C14.156 12.684 13.441 11.969 12.563 11.969C11.684 11.969 10.969 12.683 10.969 13.563C10.9669 13.8406 11.038 14.1138 11.1751 14.3552C11.3122 14.5966 11.5105 14.7976 11.75 14.938V16.438C11.75 16.656 11.937 16.813 12.156 16.813H12.969C13.187 16.813 13.375 16.656 13.375 16.438V14.938C13.6145 14.7976 13.8128 14.5966 13.9499 14.3552C14.087 14.1138 14.1581 13.8406 14.156 13.563Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.5 12C0.5 5.383 5.883 0 12.5 0C19.117 0 24.5 5.383 24.5 12C24.5 18.617 19.117 24 12.5 24C5.883 24 0.5 18.617 0.5 12ZM22.5 12C22.5 6.465 18.035 2 12.5 2C6.965 2 2.5 6.465 2.5 12C2.5 17.535 6.965 22 12.5 22C18.035 22 22.5 17.535 22.5 12Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSsl);
export default __webpack_public_path__ + "static/media/ssl.05e68b06.svg";
export { ForwardRef as ReactComponent };